module.exports = __webpack_public_path__ + "img/company-honor-VOC-20241024.fb02305c.jpg";